<template>
	<section class="page">
		<h1>something went wrong</h1>
		<p>This should not have happened.</p>
		<router-link to="/">Homepage</router-link>
	</section>
</template>